import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { UiService } from 'src/app/services/ui.service';
import { take, first } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { userFeature } from 'src/app/store/user.era';
import { PhotoComponent } from "src/app/components/photo";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IconComponent } from "src/app/components/icon/icon.component";
import { CommonModule } from '@angular/common';
import { ProfileComponent } from '../accounts/profile';

@Component({
    selector: 'view-profile-dialog',
    template: `
  <div class="worker-Profile joi-dialog">
    @if(editMode){
      <app-profile (close)="dialogRef.close()"></app-profile>
    }
    @if(!editMode){

      <div class="close" (click)="dialogRef.close()"><icon matIcon="close"></icon></div>
      <div mat-dialog-content>
          <div class="row">
              <photo [data]="data.worker" [size]="120"></photo>
          </div>
          <div class="row">
              <b>{{data.worker.firstName + ' ' + data.worker.lastName}}</b>
              <div *ngIf="data.worker.title">{{data.worker.title}}</div>
              <div *ngIf="data.worker.company">{{data.worker.company}}</div>
              <mat-progress-spinner *ngIf="loading" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
          </div>
          <div class="row">
            @if(data.worker.phone){
              <div><a [href]="'tel:' + data.worker.phone">{{ data.worker.phone }}</a></div>
            }
            <a class="secondary_link" href="mailto:{{data.worker.email}}">{{data.worker.email}}</a>
          </div>
          @if(data.worker.aboutMe){
            <div class="aboutMe" >
                <h5>About me</h5>
                <div [innerHTML]="ui.strWithBreak(data.worker.aboutMe)"></div>
            </div>
          }
      </div>
      @if(workerIsUser){
        <div mat-dialog-actions >
          <div style="flex:1;"></div>
          <button mat-button color="primary" (click)="editProfile()">EDIT PROFILE</button>
        </div>
      }
    }
  </div>
  `,
    styles: [`
  .worker-Profile { text-align: center; }
  .worker-Profile .close { position: absolute; color: rgba(0,0,0,0.4); right: 10px; top: 10px; cursor: pointer; z-index: 1; }
  .worker-Profile .row { display: flex; padding: 10px 0; line-height: 20px; flex-direction: column; align-items: center; }
  .worker-Profile .row a { color: #5A97A6; }
  .worker-Profile .aboutMe { border-top: 1px solid #ddd;  text-align: left; margin-top: 10px; padding-top: 20px; }
  .worker-Profile .aboutMe h5 { padding-bottom: 5px; }
  `],
    standalone: true,
    imports: [PhotoComponent, ProfileComponent, CommonModule, MatProgressSpinnerModule, IconComponent],
})
export class ViewProfileDialogComponent {
  loading = false;
  workerIsUser = false;
  editMode = false;
  public workforce = inject(WorkforceService)

  constructor(
    public dialogRef: MatDialogRef<ViewProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ui: UiService,
    public store: Store
  ) {
    // console.log(data);
    this.store.pipe(select(userFeature.selectUser), first()).subscribe(user => {
      // console.log({ uid, wUid: this.data.worker.uid, worker: this.data.worker })
      const uid = user?.uid
      this.workerIsUser = uid === this.data.worker.uid
    })
    if (data.worker.uid && !data.profileProvided) {
      this.loading = true;
      this.workforce.getProfile(data.worker).pipe(take(1)).subscribe(profile => {
        // console.log(profile)
        Object.assign(data.worker, profile);
        this.loading = false;
      });
    }
  }



  cancelEdit() {
    this.dialogRef.close()
  }

  changePassword() {
    console.log("Change password being called")
  }

  saveProfile() {
    console.log("Should be saving your profile")
  }

  editProfile() {
    this.editMode = true
    this.dialogRef.updateSize("690px");
    console.log("Should be editing your profile!", { data: this.data })
  }

}
